import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { getDataFields } from "../service/data-fields.api";

const {
    actions: dataFieldsActions,
    reducer: dataFieldsReducer,
    epic: dataFieldsEpic,
} = createIGSERedux<Array<string>>({
    actionNames: {
        init: "DATA_FIELDS_INIT",
        get: "DATA_FIELDS_GET",
        success: "DATA_FIELDS_SUCCESS",
        error: "DATA_FIELDS_ERROR",
    },
    fetcher: () => getDataFields(selectAuthTokens()),
    selector: (state: IRootState) => state.dataFields,
});

export { dataFieldsActions, dataFieldsReducer, dataFieldsEpic };
